import { outcomeToString } from './convert-to-ui';
import {
  StageStatus,
  StageStatusSymbol,
  StageHeaderData,
  OutcomeDetails,
  StageDetailsType,
} from './stages.model';
import { AmendmentOutcome } from '@/models';

const getStatus: (OutcomeDetails) => StageStatusSymbol = (
  details?: OutcomeDetails,
) => (details?.outcome ? StageStatus.COMPLETE : StageStatus.PENDING);

const getAdditionalOutcomeData: (OutcomeDetails) => StageHeaderData[] = (
  details?: OutcomeDetails,
): StageHeaderData[] => {
  switch (details?.outcome) {
    case AmendmentOutcome.ApprovedAndRevokedInPart:
    case AmendmentOutcome.Revoked:
      return [
        {
          label: 'Date revoked',
          value: details.revokedDate,
          type: StageDetailsType.Date,
        },
      ];
    default: {
      return [];
    }
  }
};

const getData: (OutcomeDetails) => StageHeaderData[] = (
  details?: OutcomeDetails,
) =>
  details?.outcome
    ? [
        {
          label: 'Final decision',
          value: outcomeToString(details.outcome) || 'Unknown',
          type: StageDetailsType.Text,
        },
        ...getAdditionalOutcomeData(details),
      ]
    : [
        {
          value: 'Pending',
          type: StageDetailsType.Text,
        },
      ];

export { getStatus, getData };
